/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Ok_ButtonInputs */

const en_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const fr_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const es_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo`)
};

const zh_cn2_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_audio_description_export_ok_button = /** @type {(inputs: Audio_Description_Export_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "Ok" |
*
* @param {Audio_Description_Export_Ok_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_ok_button = /** @type {((inputs?: Audio_Description_Export_Ok_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Ok_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_ok_button(inputs)
	if (locale === "de") return de_audio_description_export_ok_button(inputs)
	if (locale === "it") return it_audio_description_export_ok_button(inputs)
	if (locale === "ru") return ru_audio_description_export_ok_button(inputs)
	if (locale === "es") return es_audio_description_export_ok_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_ok_button(inputs)
	if (locale === "ja") return ja_audio_description_export_ok_button(inputs)
	if (locale === "hi") return hi_audio_description_export_ok_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_ok_button(inputs)
	return en_audio_description_export_ok_button(inputs)
});